
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_megamenu_product_section_megamenu_product_field"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_offers_pdp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_tikcer_top"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_testimonials_hp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_header_headercmsmenu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_checkout_offers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_megamenu_subcategory_section_subcategory_links"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_giftbox_order_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_giftbox_message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_checkout_guest_message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anniversary_promotion8_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anniversary_promotion8_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anniversary_promotion8_extra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anniversary_timerdatetime_catalog_msg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anniversary_timerdatetime_timer_end_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_popup_popup1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homepage_banner_popup_mobilepopup1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_website_spinthewheel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spin_the_wheel_coupon_data"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_egiftcard_banner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"egiftcard_banner_desktop_json"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"egiftcard_banner_mobile_json"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uk_redirect_home"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"global_redirect_home"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_giftwrap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"giftwrap_subtotal_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ayurvedic_gift_sku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ayurvedic_surprise_slabs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_ayurvedic_surprise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"search_noresult_bestseller_products_json"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_cod_to_preaid_on_fe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xeno_gifting_pts_to_customers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storelocator_desktop_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storelocator_mobile_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"base_media_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_us_page_blog_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_us_page_blog_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kama_kind_page_blog_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kama_kind_page_blog_ids"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1276}};
    doc.loc.source = {"body":"{\n  storeConfig {\n  homepage_banner_megamenu_product_section_megamenu_product_field \n  homepage_banner_offers_pdp\n  homepage_banner_tikcer_top\n  homepage_banner_testimonials_hp\n  id\n  homepage_banner_header_headercmsmenu\n  homepage_banner_checkout_offers\n  homepage_banner_megamenu_subcategory_section_subcategory_links\n  homepage_banner_giftbox_order_value\n  homepage_banner_giftbox_message\n  homepage_banner_checkout_guest_message\n  anniversary_promotion8_title\n  anniversary_promotion8_text\n  anniversary_promotion8_extra\n  anniversary_timerdatetime_catalog_msg\n  anniversary_timerdatetime_timer_end_time\n  homepage_banner_popup_popup1\n  homepage_banner_popup_mobilepopup1\n  enable_website_spinthewheel\n  spin_the_wheel_coupon_data\n  enable_egiftcard_banner\n  egiftcard_banner_desktop_json\n  egiftcard_banner_mobile_json\n  uk_redirect_home\n  global_redirect_home\n  enable_giftwrap\n  giftwrap_subtotal_amount\n  ayurvedic_gift_sku\n  ayurvedic_surprise_slabs\n  enable_ayurvedic_surprise\n  search_noresult_bestseller_products_json\n  enable_cod_to_preaid_on_fe\n  xeno_gifting_pts_to_customers\n  storelocator_desktop_image\n  storelocator_mobile_image\n  base_media_url\n  about_us_page_blog_title\n  about_us_page_blog_ids\n  kama_kind_page_blog_title\n  kama_kind_page_blog_ids\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
